'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useOperation = void 0;
var tslib_1 = require('tslib');
var react_1 = require('react');
var react_redux_1 = require('react-redux');
var symbols_1 = require('react-async-ssr/symbols');
var context_1 = require('../context');
var isNodeEnv_1 = require('../utils/isNodeEnv');
var services_1 = require('../services');
var useDI_1 = require('./useDI');
var DEFAULTS = {
    suspense: false,
    defaultState: { isLoading: true },
};
var PATH;
function getComponentId() {
    return {};
}
exports.useOperation = Object.assign(
    function useOperation(options) {
        var finalOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, DEFAULTS), options);
        var operationId = finalOptions.operationId,
            defaultState = finalOptions.defaultState,
            suspense = finalOptions.suspense;
        var diContext = (0, useDI_1.useDI)();
        var disableSSR = (0, react_1.useContext)(context_1.DisableSsrContext);
        if (!PATH) {
            throw new Error('Set path to operations via useOperation.setPath first');
        }
        var dispatch = (0, react_redux_1.useDispatch)();
        var service = diContext.getService(services_1.OperationService);
        var actions = diContext.createServiceActions(service);
        var componentId = (0, react_1.useMemo)(getComponentId, []);
        (0, react_1.useEffect)(function register() {
            if (service.getStatus() !== 'ready') {
                throw new Error('OperationService should be run first');
            }
            dispatch(actions.registerConsumer(componentId, operationId));
            return function unregister() {
                dispatch(actions.unregisterConsumer(componentId, operationId));
            };
        }, []);
        var operation = (0, react_redux_1.useSelector)(function getOperation(state) {
            var _a;
            return (
                ((_a = PATH === null || PATH === void 0 ? void 0 : PATH(state)) === null || _a === void 0
                    ? void 0
                    : _a.get(operationId)) ||
                defaultState ||
                {}
            );
        });
        if (!operation) {
            return operation;
        }
        var isLoading = operation.isLoading,
            error = operation.error;
        if (suspense && isLoading) {
            var promise = service.subscribeOperation(operationId);
            if (disableSSR && (0, isNodeEnv_1.isNodeEnv)()) {
                promise[symbols_1.NO_SSR] = true;
            }
            throw promise;
        }
        if (suspense && error) {
            throw error;
        }
        return operation;
    },
    {
        setPath: function (path) {
            PATH = path;
        },
    }
);
